module.exports = __webpack_public_path__ + "img/dashboard.a6997a12.gif";